import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { Props } from '../SvgProps';

const DelayedParts = ({ color = 'black' }: Props) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <Path
      d="M12 6V12L16 14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M20 12V17"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M20 21H20.01"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M21.2497 8.19954C20.4954 6.36091 19.2104 4.78873 17.5586 3.68366C15.9068 2.57859 13.9632 1.99074 11.9759 1.99514C9.98856 1.99954 8.0476 2.596 6.40074 3.70837C4.75388 4.82075 3.47581 6.3986 2.72965 8.24056C1.98349 10.0825 1.80308 12.105 2.21144 14.0499C2.61981 15.9949 3.59843 17.774 5.02241 19.1603C6.44638 20.5466 8.25113 21.4772 10.2063 21.8333C12.1615 22.1894 14.1784 21.9548 15.9997 21.1595"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default DelayedParts;
